import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "../context/Authcontext";
import axios from "axios";
import SupportAndDownloadButtons from "../views/components/SupportAndDownloadButtons";
import { useSupportContacts, whatsappUrl } from "../utils/useSupportContacts";
export const Footer = () => {
  // WhatsApp / Telegram as configured in Admin -> Accounts.
  const support = useSupportContacts();
  const supportWa = whatsappUrl(support?.whatsapp);
  const supportTg = support?.telegram || "";
  const navigate = useNavigate();

  const handleFooterLink = () => {
    toast.success("Coming Soon!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit= async()=>{
    const token=localStorage.getItem('game_token');
    try{
      const response= await axios.post(base_url + '/api/webapi/casinoLobby',{token},
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
          }
        }
      )
  
      // console.log('lobby',response);
      if(response?.data.success){
        window.location.href=response?.data.url;
      }else{
        toast.error(response?.data.message);
      }
  
    }catch(err){
      console.log(err);
    }
  }
  
  const [isOpen, setIsOpen] = useState(false);

  const toggleDetails = () => {
    setIsOpen(!isOpen);
  };

  const openWhatsAppChat = () => {
    if (!supportWa) {
      alert("WhatsApp number not available");
      return;
    }
    window.open(supportWa, "_blank", "noopener,noreferrer");
  };



  return (
    <>
      <footer
        _ngcontent-mkq-c100=""
        style={{ marginBottom: "45px" }}
        className="ng-tns-c100-1  footer-responsive"
      >
        <div
          _ngcontent-mkq-c100=""
          className="max-width content-padding ng-tns-c100-1"
        >
          <div
            _ngcontent-mkq-c100=""
            className="footer-nav-items ng-tns-c100-1"
          >
            <app-footer
              _ngcontent-mkq-c100=""
              className="ng-tns-c100-1"
              _nghost-mkq-c92=""
            >
              <section
                _ngcontent-mkq-c92=""
                className="footers-container-second ng-star-inserted"
              >
                <footer _ngcontent-mkq-c92="" >
                  <div
                    _ngcontent-mkq-c92=""
                    className="footer max-width"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      _ngcontent-mkq-c92=""
                      className="links footer-row content-padding w-100"
                    >
                      <div
                        _ngcontent-mkq-c92=""
                        className="footer-nav max-footer-width"
                      >
                        <div _ngcontent-mkq-c92="" className="navbar-header">
                          <div
                            _ngcontent-mkq-c92=""
                            className="social-icons text-left"
                            style={{ display: "none" }}
                          >
                            <ul _ngcontent-mkq-c92="">
                              <li
                                _ngcontent-mkq-c92=""
                                className="inline-block"
                              >
                                <Link
                                  _ngcontent-mkq-c92=""
                                  href="https://www.facebook.com/btc.bahis"
                                  target="_blank"
                                  rel="noopener"
                                  aria-hidden="true"
                                  className="icon icon-tb-facebook"
                                ></Link>
                              </li>
                              <li
                                _ngcontent-mkq-c92=""
                                className="inline-block"
                              >
                                <Link
                                  _ngcontent-mkq-c92=""
                                  href="https://twitter.com/bozdurgitsintr"
                                  target="_blank"
                                  rel="noopener"
                                  aria-hidden="true"
                                  className="icon icon-tb-twitter"
                                ></Link>
                              </li>
                              <li
                                _ngcontent-mkq-c92=""
                                className="inline-block"
                              >
                                <Link
                                  _ngcontent-mkq-c92=""
                                  href="https://www.instagram.com/bozdurgitsintr"
                                  target="_blank"
                                  rel="noopener"
                                  aria-hidden="true"
                                  className="icon icon-tb-instagram"
                                ></Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div _ngcontent-mkq-c92="">
                          <div
                            _ngcontent-mkq-c92=""
                            className="license-column-holder"
                          >
                            <div
                              _ngcontent-mkq-c92=""
                              className="download-btn ng-star-inserted"
                              onClick={handleFooterLink}
                            >
                              {/* <Link
                                _ngcontent-mkq-c92=""
                                className="btn-cls download"
                                href="/"
                              >
                                <img
                                  _ngcontent-mkq-c92=""
                                  src="/assets/images/download-icon.svg"
                                  alt="download-icon_Kheloyaar360"
                                />
                                <p _ngcontent-mkq-c92="">Download App</p>
                              </Link> */}
                            </div>

                            <div
                              _ngcontent-mkq-c92=""
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Link
                                _ngcontent-mkq-c92=""
                                className="btn_wrapper "
                              >
                                <button
                                  _ngcontent-mkq-c92=""
                                  type="button"
                                  className="button-1 for-img"
                                >
                                  <img
                                    _ngcontent-mkq-c92=""
                                    src="/assets/images/whatsappImages.svg"
                                    alt="chat icon_Kheloyaar360"
                                    className="ng-star-inserted"
                                  />
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="livebtn ng-star-inserted"
                                  >
                                    Get Instant ID on WhatsApp
                                  </span>
                                </button>
                              </Link>
                            </div>
                            <div style={{ marginTop: '20px' }}>
      <div className="footer-content-section mb-1">
        <details className="content-detail" open={isOpen}>
          <summary
            className="rounded d-flex p-1 bg-tab align-items-center justify-content-between"
            onClick={toggleDetails}

            style={{background:"#212121",fontFamily:"sans-serif"}}
          >
            <p className="fs-15 summary-heading p-2 mb-0 sm-fs-13">
              Grab the best wins in Rajbet65 The home of Casino, Cricket, Horse Racing, Football and many more.
            </p>
            <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'} fs-15 summary-dropdown-icon me-2`}></i>
          </summary>
          <div className="content-body p-3">
            <p className="summary-content sm-fs-12">
              Waiting for a chance to frame up wins in online gaming? Rajbet65 has you covered, and we are bringing you a fun, fast, and fair online gaming and casino experience like no other. When it comes to sports, KHELOYAAR is always on the high, and we are here to help you create the most of your winning experiences.
            </p>
            <p className="summary-content sm-fs-12">
              Wait no more and win big in sports gaming at Rajbet65!
            </p>
          </div>
        </details>
      </div>
      <div className="text-center mt-2">
        <span>
          <i
            className={`summary-show-more-icon ${isOpen ? '' : 'blinking'} fs-20 pointer bi bi-chevron-down`}
            onClick={toggleDetails}
          ></i>
        </span>
      </div>
    </div>
  
                            <div
                              _ngcontent-mkq-c92=""
                              className="tut-class ng-star-inserted"
                            >
                              <span _ngcontent-mkq-c92="">Tutorials</span>
                            </div>
                            <div
                              _ngcontent-mkq-c92=""
                              className="tutorials ng-star-inserted"
                            >
                              <span
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted"
                                onClick={handleFooterLink}
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="tutorial-btn"
                                >
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="tut-span"
                                  >
                                    <Link _ngcontent-mkq-c92="">
                                      <div>How to Signup ?</div>
                                      <div>
                                        <img src="/assets/all_images/sidebar/v1.svg" alt="" />
                                      </div>
                                    </Link>
                                  </span>
                                </div>
                              </span>
                              <span
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted"
                                onClick={handleFooterLink}
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="tutorial-btn"
                                >
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="tut-span"
                                  >
                                    <Link _ngcontent-mkq-c92="">
                                      <div>How to Login ?</div>
                                      <div>
                                      <div>
                                        <img src="/assets/all_images/sidebar/v1.svg" alt="" />
                                      </div>
                                      </div>
                                    </Link>
                                  </span>
                                </div>
                              </span>
                              <span
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted"
                                onClick={handleFooterLink}
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="tutorial-btn"
                                >
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="tut-span"
                                  >
                                    <Link _ngcontent-mkq-c92="">
                                      <div>How to Deposit ?</div>
                                      <div>
                                      <div>
                                        <img src="/assets/all_images/sidebar/v1.svg" alt="" />
                                      </div>
                                      </div>
                                    </Link>
                                  </span>
                                </div>
                              </span>
                              <span
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted"
                                onClick={handleFooterLink}
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="tutorial-btn"
                                >
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="tut-span"
                                  >
                                    <Link _ngcontent-mkq-c92="">
                                      <div>How to Withdraw </div>
                                      <div>
                                      <div>
                                        <img src="/assets/all_images/sidebar/v1.svg" alt="" />
                                      </div>
                                      </div>
                                    </Link>
                                  </span>
                                </div>
                              </span>
                              <span
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted"
                                onClick={handleFooterLink}
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="tutorial-btn"
                                >
                                  <span
                                    _ngcontent-mkq-c92=""
                                    className="tut-span"
                                  >
                                    <Link _ngcontent-mkq-c92="">
                                      <div>How to Play ?</div>
                                      <div>
                                      <div>
                                        <img src="/assets/all_images/sidebar/v1.svg" alt="" />
                                      </div>
                                      </div>
                                    </Link>
                                  </span>
                                </div>
                              </span>
                            </div>

                          

                            <div
                              _ngcontent-mkq-c92=""
                              className="payment-img-holder ng-star-inserted"
                             
                            ></div>
                            <div
                              _ngcontent-mkq-c92=""
                              className="footer ng-star-inserted"
                            >
                              <div
                                _ngcontent-mkq-c92=""
                                className="max-footer-width"
                              >
                                <div
                                  _ngcontent-mkq-c92=""
                                  className="footer-grid-layout"
                                >
                                  <div
                                    _ngcontent-mkq-c92=""
                                    className="curacao"
                                  >
                                 
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-mkq-c92=""
                              className="footer_link ng-star-inserted  linewish  d-flex justify-content-around"
                            >
                                 <div  className="hlpp"> <SupportAndDownloadButtons></SupportAndDownloadButtons></div>


                              <div
                                _ngcontent-mkq-c92=""
                                className="primary ng-star-inserted"
                              >

                                
                                
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  <div
                              _ngcontent-mkq-c92=""
                              className="img-holder ng-star-inserted"
                              style={{maxWidth:"331px"}}
                            >
                              <div _ngcontent-mkq-c92="" className="row hhpp justify-content-start">
                                <Link to="/" aria-label="Rajbet65 home">
                                  <img
                                    _ngcontent-mkq-c92=""
                                    alt="Rajbet65"
                                    className="logo"
                                    src="/assets/images/rajbet65-logo.png"
                                  />
                                </Link>
                              </div  >
                              <div   className="text-lg-left  "  style={{fontFamily:"sans-serif",fontSize:"14px",padding:"5px",color:"#727271"}}> Welcome to Rajbet65, the ultimate destination for safe, exciting, and profitable online betting! At Rajbet65, we are committed to providing our users with the highest level of security, ensuring your personal information and funds are always protected with state-of-the-art encryption technology.</div>
                            </div>
                         
                                </span>
                               
                              </div>
                             <div className="d-flex  gap-5  d-flex justify-content-around"    style={{lineHeight:"35px",fontFamily:"sans-serif",color:"#727271"}}>
                             <div
                                _ngcontent-mkq-c92=""
                                className="primary ng-star-inserted  text-nowrap"
                              >

                                
                                <span _ngcontent-mkq-c92="" className="header">
                                  PRIMARY{" "}
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  All Sports
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  In-Play
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  All Casinos
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  Blogs
                                </span>
                              </div>

                              <div
                                _ngcontent-mkq-c92=""
                                className="setting ng-star-inserted  text-nowrap"
                              >
                                <span _ngcontent-mkq-c92="" className="header">
                                  SETTINGS
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  Contact Us
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  Cookie Policy
                                </span>
                                {/* <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  Responsible Gambling
                                </span>
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  Terms &amp; Conditions
                                </span> */}
                                <span
                                  _ngcontent-mkq-c92=""
                                  className="ng-star-inserted"
                                >
                                  About Us
                                </span>
                                
                              </div>
                             </div>
                              <div
                                _ngcontent-mkq-c92=""
                                className=" ng-star-inserted  hlp"
                              >
                                <span _ngcontent-mkq-c92="" className="header">
                                  JOIN OUR COMMUNITY
                                </span>
                              {/* These were another brand's Facebook, YouTube,
                                  Instagram and Telegram, inherited with the
                                  template. Only our own channels, from
                                  Admin -> Accounts, are linked now. */}
                              <div  className="d-flex gap-3  justify-content-center " >
      {supportWa && (
        <a href={supportWa} target="_blank" rel="noopener noreferrer">
          <img
            alt="WhatsApp"
            src="/assets/images/whatsappImages.svg"
            title="WhatsApp support"
            width="40"
            height="40"
          />
        </a>
      )}
      {supportTg && (
        <a href={supportTg} target="_blank" rel="noopener noreferrer">
          <img
            alt="Telegram"
            src="/assets/all_images/grid/f4.png"
            title="Telegram support"
          />
        </a>
      )}
                              </div>
                            <div  className="hlpa"> <SupportAndDownloadButtons></SupportAndDownloadButtons></div>
                                
                              </div>
          
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </section>
              <div   style={{ color: "#727271", textAlign: "center",fontFamily:"sans-serif",marginBottom:"-39px"}}>
              Copyright (c){new Date().getFullYear()} Rajbet65. ALL RIGHTS RESERVED
    </div>

              {/* <div _ngcontent-mkq-c92="" className="flexout ng-star-inserted">
                <Link
                  _ngcontent-mkq-c92=""
                  target="_blank"
                  href="https://www.facebook.com/kheloyar.official"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-mkq-c92=""
                    className="social2"
                    alt="Facebook_Kheloyaar360"
                    src="/assets/images/82.png"
                  />
                </Link>
                <Link
                  _ngcontent-mkq-c92=""
                  target="_blank"
                  href="https://x.com/"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-mkq-c92=""
                    className="social2"
                    alt="twitter_Kheloyaar360"
                    src="/assets/images/86.png"
                  />
                </Link>
                <Link
                  _ngcontent-mkq-c92=""
                  target="_blank"
                  href="https://www.youtube.com/channel/UCC-hnRPCNylFw8usx32y8sQ"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-mkq-c92=""
                    className="social2"
                    alt="youtube_Kheloyaar360"
                    src="/assets/images/6.png"
                  />
                </Link>
                <Link
                  _ngcontent-mkq-c92=""
                  target="_blank"
                  href="https://www.instagram.com/kheloyar_club_net/"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-mkq-c92=""
                    className="social2"
                    alt="Instagram_Kheloyaar360"
                    src="/assets/images/7.png"
                  />
                </Link>
                <Link
                  _ngcontent-mkq-c92=""
                  target="_blank"
                  href="https://t.me/kheloyarclub"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-mkq-c92=""
                    className="social2"
                    alt="Telegram_Kheloyaar360"
                    src="/assets/images/9.png"
                  />
                </Link>
              </div> */}
            </app-footer>
          </div>
        </div>
      </footer>
      <app-sitefooter
        _ngcontent-mkq-c100=""
        className="ng-tns-c100-1"
        _nghost-mkq-c94=""
      >
        <div
          _ngcontent-mkq-c94=""
          id="site_footer-settings"
          className="site_footer"
          style={{ display: "block" }}
        >
          <div _ngcontent-mkq-c94="" className="site_footer_inn">
            <ul _ngcontent-mkq-c94="" className="nav-bottom-site site-ui-inn">
              <li _ngcontent-mkq-c94="" className="active">
                <Link
                  _ngcontent-mkq-c94=""
                  to="/"
                >
                  <img
                    src="/assets/images/27500.png"
                    alt=""
                    _ngcontent-mkq-c94=""
                    className="sport new_home_icon new_home_icon_yellow"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style" style={{fontSize:'0.7rem'}}>
                    Home
                  </span>
                </Link>
              </li>
              <li _ngcontent-mkq-c94=""
              
             onClick={() => navigate('/casinoGames')}>
                <Link
                  
                  _ngcontent-mkq-c94=""
                  routerlink="/casinos/get/all"
              
                >
                  <img
                    src="/assets/images/9383.png"
                    _ngcontent-mkq-c94=""
                    className="casino new_casino_icon new_casino_yellow"
                    alt=""
                  />
                  <span _ngcontent-mkq-c94="" className="name-style" style={{fontSize:'0.7rem'}}>
                    Casinos
                  </span>
                </Link>
              </li>
              <li
                _ngcontent-mkq-c94=""
                className="whatsApp-section ng-star-inserted"
                onClick={openWhatsAppChat}
              >
                <Link
                  _ngcontent-mkq-c94=""
                  target="_blank"
                  className="whatsApp circle"
                >
                  <i
                    _ngcontent-mkq-c94=""
                    className="fa fa-whatsapp"
                    aria-hidden="true"
                  ></i>
                </Link>
              </li>

              <li
                _ngcontent-mkq-c94=""
                // routerlink="/sports"
                className="hide-specific ng-star-inserted"
                tabIndex={0}
                 onClick={() => navigate('/sportall')}
              >
                <Link _ngcontent-mkq-c94=""
                >
                  <img
                    src="/assets/images/27498.png"
                    alt=""
                    _ngcontent-mkq-c94=""
                    className="liveCasinoss"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style" style={{fontSize:'0.7rem'}}>
                    Sports
                  </span>
                </Link>
              </li>

              <li _ngcontent-mkq-c94="">
                <Link _ngcontent-mkq-c94="" to='/menu'>
                  <img
                    _ngcontent-mkq-c94=""
                    className="icon-navbar-site"
                    style={{ maxWidth: "18px" }}
                    alt="icon_Kheloyaar360"
                    src="/assets/images/More22.svg"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style" style={{fontSize:'0.7rem'}}>
                    Menu
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </app-sitefooter>
    </>
  );
};